angular.module('dictionary', ['core'])
    .factory('Dictionary', function ($resource) {
        return $resource('/crm/api/:type/:id', {type: "@type"}, {
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'}
        });
    })
    .service('DictionaryService', function ($rootScope, modals, Dictionary) {
        this.addModal = TYPE => {
            let entity = {
                id: null,
                type: TYPE
            };
            return editModal(entity);
        };
        this.edit = (TYPE, id) => {
            Dictionary.get({type: TYPE, id: id}, entity => {
                entity.type = TYPE;
                editModal(entity);
            });
        };
        this.list = type => {
            return modals.open('app/dictionary/list-modal.html', 'DictionaryListController', {type: type}, {size: 'md'}, "$ctrl");
        };
        this.remove = (TYPE, item) => {
            return modals.confirmDelete(item.name, () => Dictionary.delete({type: TYPE, id: item.id}, () => $rootScope.$broadcast(`dictionary-${TYPE}.updated`)).$promise);
        };

        function editModal(entity) {
            return modals.open('app/dictionary/edit-modal.html', 'DictionaryDialogController', entity, {}, "$ctrl")
        }
    })
